// ============================================================
// components/catalogo/ProductPreview.jsx — Preview de producto + contexto IA
// ============================================================

import React from 'react';

const ZONAS = ['Todas', 'Almirante Brown', 'Florencio Varela', 'Capitán Sarmiento'];

function money(value) {
  if (!value) return 'A definir';
  return '$' + Number(value).toLocaleString('es-AR');
}

function ProductPreview({ product, zona, onToggleZone, contextoIA }) {
  if (!product) {
    return (
      <div className="cat-panel cat-preview-panel cat-preview-empty">
        <div className="cat-preview-empty-content">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.3"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          <p>Seleccioná un producto para ver su vista previa comercial y el contexto que recibirá la IA.</p>
        </div>
      </div>
    );
  }

  // Generar contexto IA individual del producto seleccionado
  const iaContextProduct = [
    `[CATALOGO_COMERCIAL]`,
    `Zona consultada: ${zona}`,
    ``,
    `Producto disponible:`,
    `- ${product.name}`,
    `  Familia: ${product.family}`,
    `  Tipo: ${product.type}`,
    product.tv ? `  TV: ${product.signals} señales` : '  TV: no incluida',
    `  Precio lista: ${money(product.list_price)}`,
    `  Precio transferencia / Mercado Pago: ${money(product.transfer_price)}`,
    `  Precio tarjeta crédito: ${money(product.card_price)}`,
    `  Uso sugerido: ${product.recommended_use}`,
    `  Descripción: ${product.description}`,
    product.condiciones_contratacion ? `  Condiciones de contratación: ${product.condiciones_contratacion}` : null
  ].filter(Boolean).join('\n');

  return (
    <div className="cat-panel cat-preview-panel">
      {/* Hero */}
      <div className="cat-preview-hero">
        <div className="cat-icon-bubble">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12.55a11 11 0 0114.08 0"/><path d="M1.42 9a16 16 0 0121.16 0"/><path d="M8.53 16.11a6 6 0 016.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg>
        </div>
        <div>
          <div className="cat-eyebrow">Vista previa comercial</div>
          <h2>{product.name}</h2>
          <p>{product.description}</p>
        </div>
      </div>

      {/* Price grid */}
      <div className="cat-price-grid">
        <div>
          <span>Lista</span>
          <b>{money(product.list_price)}</b>
        </div>
        <div>
          <span>MP / Transf.</span>
          <b>{money(product.transfer_price)}</b>
        </div>
        <div>
          <span>Tarjeta crédito</span>
          <b>{money(product.card_price)}</b>
        </div>
      </div>

      {/* Badges */}
      <div className="cat-chips">
        <span className="cat-badge blue">{product.speed}</span>
        {product.tv && <span className="cat-badge violet">TV {product.signals} señales</span>}
        {product.featured && <span className="cat-badge gold">Destacado IA</span>}
        {!product.active && <span className="cat-badge muted">Inactivo</span>}
      </div>

      {/* Condiciones de contratación */}
      {product.condiciones_contratacion && (
        <div className="cat-zone-check-panel">
          <div className="cat-zone-check-title">
            📝 Condiciones de contratación
          </div>
          <p style={{ margin: '0', color: '#c1c9db', fontSize: '13px', lineHeight: '1.5' }}>
            {product.condiciones_contratacion}
          </p>
        </div>
      )}

      {/* Zone checks */}
      <div className="cat-zone-check-panel">
        <div className="cat-zone-check-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
          Localidades donde aplica
        </div>
        <div className="cat-zone-checks">
          {ZONAS.map(z => (
            <label
              key={z}
              className={`cat-zone-check ${product.zones.includes(z) ? 'checked' : ''}`}
            >
              <input
                type="checkbox"
                checked={product.zones.includes(z)}
                onChange={() => onToggleZone(product.id, z)}
              />
              <span>{z}</span>
            </label>
          ))}
        </div>
        <p>Si marcás "Todas", el plan queda disponible para cualquier localidad.</p>
      </div>

      {/* Contexto IA del producto */}
      <div className="cat-context-box">
        <div className="cat-context-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          Contexto que recibirá la IA (este producto)
        </div>
        <pre>{iaContextProduct}</pre>
      </div>

      {/* Contexto IA completo de la zona (colapsable) */}
      {contextoIA && (
        <details className="cat-context-details">
          <summary className="cat-context-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            Contexto IA completo — {zona}
          </summary>
          <pre>{contextoIA}</pre>
        </details>
      )}
    </div>
  );
}

export default ProductPreview;
